import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadFileButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddPayableRegister from "../Forms/AddPayablesRegister/AddPayableRegister";
import UploadPayableFile from "../Forms/UploadPayableFile/UploadPayableFile";
import PayableUploadedFiles from "../Forms/PayableUploadedFiles/PayableUploadedFile";
import ColumnMapping from "../Forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../Forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import { getPayableListing, getPayable } from "../../../Bookclosure/Services/ApiHandler";
import receCss from "../../css/receivablesListing.module.css";
import { ReactComponent as CalenderIcon } from "../../assets/icons/Calendar.svg";
import styles from "./Header.module.css";
import { useLocation } from "react-router-dom";
const PayablesHeaders = ({
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
  PayableID
}) => {

  const location = useLocation();
  const { asOnDate: passedAsOnDate } = location.state || {};
  const [asOnDate, setAsOnDate] = useState(passedAsOnDate || "");
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showPayableUploadedFiles, setShowPayableUploadedFiles] = useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadType, setUploadType] = useState(null);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);
  const [columnMappingData, setColumnMappingData] = useState({});
  const [perFileMappingData, setPerFileMappingData] = useState({});
  const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        const response = await getPayableListing(PayableID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });

        if (response.data) {
          if (response.data.filterAndAlignment) {
            setFilterConfig(response.data.filterAndAlignment);
          }
          if (response.data.payableListing && response.data.payableListing.length > 0) {
            setShowTable(true);
            setShowDataState(false);
            setTableType("excel");
          }
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    if (PayableID) {
      fetchFilterConfig();
    }
  }, [PayableID]);

  useEffect(() => {
  if (!passedAsOnDate && PayableID) {
    getPayable(PayableID).then((res) => {
      const data = res.data.Payable?.[0];
      if (data?.asOnDate) {
        setAsOnDate(data.asOnDate);
      }
    });
  }
}, [PayableID, passedAsOnDate]);

  const handleRemoveFile = (index) => {
    setUploadedFiles((prev) => {
      console.log("Removed file:", prev[index]?.name);
      const newFiles = prev.filter((_, i) => i !== index);
      return newFiles;
    });
  };

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
    }
  };

  const handleChangeFile = () => {
    setShowUploadExcelModal(true);
    setShowUploadFileModal(false);
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleAddFiles = () => {
    setShowUploadFileModal(true);
    setShowPayableUploadedFiles(false);
  };

  const handleProceedToPayableUploadedFiles = (files) => {
    const normalized = (files || []).map((file) => {
      const computedName =
        file?.name ||
        file?.fileName ||
        file?.originalname ||
        file?.file?.name ||
        file?.file?.fileName ||
        file?.file?.originalname ||
        "Untitled file";

      const fileId = `${computedName}-${file?.size || 0}-${file?.lastModified || 0}`;

      return {
        id: fileId,
        rawFile: file,
        displayName: computedName,
        isMapped: false,
        mappedValues: {},
      };
    });
    setUploadedFiles((prev) => [...prev, ...normalized]);
    setShowUploadFileModal(false);
    setShowPayableUploadedFiles(true);
  };

  const handleStartMapping = (index) => {
    setSelectedFileIndex(index);
    const file = uploadedFiles[index];
    const mappedFromFile = file?.mappedValues || perFileMappingData[file?.id] || {};
    setColumnMappingData(mappedFromFile);
    setShowPayableUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmappingSuccess = () => {
    if (selectedFileIndex !== null) {
      const selectedFile = uploadedFiles[selectedFileIndex];
      const fileId = selectedFile?.id;

      setUploadedFiles((prev) =>
        prev.map((file, idx) =>
          idx === selectedFileIndex
            ? { ...file, isMapped: true, mappedValues: columnMappingData }
            : file
        )
      );

      if (fileId) {
        setPerFileMappingData((prev) => ({
          ...prev,
          [fileId]: columnMappingData,
        }));
      }
    }

    setShowSubMapping(false);
    setShowPayableUploadedFiles(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowPayableUploadedFiles(true);
  };

  const handleFinish = () => {
    const canFinish = uploadedFiles.some((file) => file.isMapped);
    if (!canFinish) {
      alert("Please map at least one file before finishing.");
      return;
    }

    setShowPayableUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");

    setShowTable(false);
    setTimeout(() => {
      setShowTable(true);
    }, 0);
  };

  const handleSuccessERPModal = () => {
    setShowERPModal(false);
    setShowERPSuccessModal(true);
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    setShowTable(true);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          {/* <Datepicker
            fromDate={fromDate}
            toDate={toDate}
            onFromChange={(e) => setFromDate(e.target.value)}
            onToChange={(e) => setToDate(e.target.value)}
          /> */}

          <div className={receCss.calenderContainer}>
              <div className={receCss.CalenderContainer}>
                <div className={receCss.calenderLabels}>As On</div>
                 {asOnDate && (
                    <div className={receCss.calenderDate}>
                      {formatDate(asOnDate)}
                    </div>
                  )}
                <div className={receCss.calenderIconContainer}>
                  <CalenderIcon />
                </div>
               </div>
          </div> 

          {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )}
          {tableType === "excel" && (
            <UploadFileButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddPayableRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false); 
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadPayableFile
          PayableID={PayableID}
          onClose={() => setShowUploadFileModal(false)}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onChangeFile={handleChangeFile}
          onProceedToPayableUploadedFiles={handleProceedToPayableUploadedFiles}
        />
      )}

      {showPayableUploadedFiles && (
        <PayableUploadedFiles
          uploadedFiles={uploadedFiles}
          canFinish={uploadedFiles.some((file) => file.isMapped)}
          onBack={() => {
            setShowPayableUploadedFiles(false);
            setShowUploadFileModal(true);
          }}
          onAdd={handleAddFiles}
          onStartMapping={handleStartMapping}
          onFinish={handleFinish}
          onRemove={handleRemoveFile}
          onClose={() => setShowPayableUploadedFiles(false)}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          key={PayableID}
          PayableID={PayableID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowPayableUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onCancel={() => {
            setShowColumnMapping(false);
          }}
          onClose={() => {
            setShowColumnMapping(false);
          }}
          mappedValues={columnMappingData}
          setMappedValues={setColumnMappingData}
        />
      )}

      {showSubMapping && (
        <Submapping
          PayableID={PayableID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onClose={() => {
            setShowSubMapping(false);
          }}
          onCancel={() => {
            setShowSubMapping(false);
          }}
          onMapped={handleSubmappingSuccess}
          onSubmitMapping={handleSubmitSubMapping}
        />
      )}

      {showERPModal && (
        <ERPModal
          onClose={() => setShowERPModal(false)}
          onBack={() => {
            setShowERPModal(false);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
        />
      )}

      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}
    </>
  );
};

export default PayablesHeaders;